export default "__VITE_ASSET__DUPfKAdC__"